import { createTheme } from "@mui/material/styles";

const theme = createTheme({
    typography: {
        // h1: {
        //     fontSize: "1rem",
        //     "@media (min-width:950px)": {
        //         fontSize: "1rem",
        //     },
        //     fontFamily: "Roboto",
        // },
        h2: {
            fontSize: "1.8rem",
            fontWeight: "400",
            "@media (min-width:600px)": {
                fontSize: "2.8rem",
            },
            fontFamily: "Roboto",
        },
        h3: {
            fontSize: "2rem",
            "@media (min-width:600px)": {
                fontSize: "2.9rem",
            },
            "@media (min-width:1200px)": {
                fontSize: "3.1rem",
            },
            fontFamily: "Roboto",
        },
        h4: {
            fontSize: "1.3rem",
            "@media (min-width:600px)": {
                fontSize: "1.1rem",
            },
            fontFamily: "Roboto",
        },
        h5: {
            fontSize: "1rem",
            fontFamily: "Roboto",
            "@media (min-width:600px)": {
                fontSize: "1rem",
            },
        },
        h6: {
            fontSize: "1rem",
            fontFamily: "Roboto",
            "@media (min-width:600px)": {
                fontSize: "1rem",
            },
        },
        body2: {
            fontSize: "0.8rem",
            fontFamily: "Roboto",
            color: "#434749",
        },
        subtitle1: {
            fontSize: "16px",
            fontFamily: "Roboto",
        },
        subtitle2: {
            fontSize: "14px",
            fontFamily: "Roboto",
            color: "black",
        },
        allVariants: {
            color: "#434749",
            fontFamily: "Roboto",
        },
    },
    palette: {
        primary: {
            main: "#E51846",
        },
        secondary: {
            main: "#EEF7F5",
        },
        info: {
            main: "#FFF",
        },
    },
});

export default theme;
